//#region src/lib/utils.mts
var e = "C0004:0", t = "/consent/heartbeat", n = (e) => {
	let t = `; ${document.cookie}`.split(`; ${e}=`);
	if (t.length === 2) return t.pop()?.split(";").shift();
}, r = () => {
	let e = n("loggedin"), t = window.location.hostname.endsWith(".rentals.rei.com") || window.location.hostname.endsWith(".next-rentals.rei.com");
	return !!e || t;
}, i = () => (document.referrer || "").includes("/login") && r(), a = () => {
	let t = n("OptanonConsent");
	if (!t) return !1;
	let r = decodeURIComponent(t).split("&").find((e) => e.startsWith("groups="));
	return r ? r.replace("groups=", "").split(",").includes(e) : !1;
}, o = () => [
	"https://future.rei.com",
	"https://next.rei.com",
	"https://www.rei.com"
].includes(window.location.origin) ? `${window.location.origin}${t}` : `${window.location.hostname.endsWith(".rentals.rei.com") ? "https://www.rei.com" : "https://next.rei.com"}${t}`, s = () => r() && !a() && !navigator.globalPrivacyControl, c = "X-IS-OPTED-OUT", l = "rei-heartbeat-last-checked", u = 36e5, d = !1, f = () => n(c) === "true", p = () => {
	if (window.OneTrust !== void 0 && typeof window.OneTrust.UpdateConsent == "function") {
		window.OneTrust.UpdateConsent("Category", e), y();
		return;
	}
	if (d) return;
	d = !0;
	let t = 0, n = window.setInterval(() => {
		t++, window.OneTrust !== void 0 && typeof window.OneTrust.UpdateConsent == "function" ? (window.clearInterval(n), y(), d = !1, window.OneTrust.UpdateConsent("Category", e)) : t >= 50 && (window.clearInterval(n), d = !1, console.warn("OneTrust failed to load after 50 seconds"));
	}, 1e3);
}, m = () => {
	let e = sessionStorage.getItem(l);
	if (!e) return 0;
	let t = u - (Date.now() - parseInt(e, 10));
	return t > 0 ? t : 0;
}, h = () => {
	if (!s()) return Promise.resolve(!1);
	if (v !== null) return v;
	let e = (async () => {
		try {
			let e = await fetch(o(), { credentials: "include" });
			if (!e.ok) throw Error(`Heartbeat failed with status: ${e.status}`);
			let t = await e.json();
			if (sessionStorage.setItem(l, Date.now().toString()), t.thirdPartyOptOut === !0) return p(), console.error("triggerCmpOptout triggered", t.thirdPartyOptOut), !0;
		} catch (e) {
			console.error("Error running heartbeat:", e);
		} finally {
			v = null;
		}
		return !1;
	})();
	return v = e, e;
}, g = null, _ = null, v = null, y = () => {
	g !== null && (clearTimeout(g), g = null), _ !== null && (clearInterval(_), _ = null);
}, b = () => {
	_ === null && (_ = window.setInterval(() => {
		h().catch((e) => console.error("Periodic heartbeat execution error:", e));
	}, u));
}, x = () => {
	y();
	let e = m();
	e === 0 ? h().then(() => b()).catch((e) => console.error("Initial heartbeat execution error:", e)) : g = window.setTimeout(() => {
		g = null, h().then(() => b()).catch((e) => console.error("Scheduled heartbeat execution error:", e));
	}, e);
}, S = () => (console.log("Running opt-out listener"), i() && f() ? (p(), !0) : (s() && x(), !1));
//#endregion
export { S as optoutListener };
